import { render, staticRenderFns } from "./DrugEdit.vue?vue&type=template&id=391b4e5d&scoped=true&"
import script from "./DrugEdit.vue?vue&type=script&lang=js&"
export * from "./DrugEdit.vue?vue&type=script&lang=js&"
import style0 from "./DrugEdit.vue?vue&type=style&index=0&id=391b4e5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391b4e5d",
  null
  
)

export default component.exports